import {Pipe, PipeTransform}   from '@angular/core';
import {DeviceDetectorService} from "ngx-device-detector";
import {
  TypeHeaderParameters
} from "../../components/main/self-care/preconisation-selfcare/preconisation-selfcare.constants";

@Pipe({standalone:true,name: 'SizeBottomExpansion'})
export class SizeBottomExpansion implements PipeTransform {

    constructor(private deviceService: DeviceDetectorService) {
    }
    transform(t: TypeHeaderParameters[], eligibitesEmprunt: boolean): any {
        let size = t.length * 20;
        if(eligibitesEmprunt) {
            size+= 20;
        }
        return this.deviceService.isMobile() ? {'width': `100%`} : {'width': `${size}%`};
    }
}

